var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5445_82997)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5445_82997",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5445_82997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.703127C5.78681 0.703127 0.703125 5.78681 0.703125 12C0.703125 18.2132 5.78681 23.2969 12 23.2969C18.2132 23.2969 23.2969 18.2132 23.2969 12C23.2969 5.78681 18.2132 0.703127 12 0.703127Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0725 16.5913L13.7051 20.2656C16.9972 19.5902 19.5901 16.9973 20.2656 13.7052L16.5912 14.0726C15.2592 14.2058 14.2057 15.2593 14.0725 16.5913Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92741 16.5913L10.2948 20.2656C7.00269 19.5902 4.4098 16.9973 3.73438 13.7052L7.40872 14.0726C8.74067 14.2058 9.79419 15.2593 9.92741 16.5913Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70375 9.89994C8.29077 9.84125 8.7777 9.42036 8.92077 8.84806C9.07728 8.22205 9.63978 7.78283 10.2851 7.78283H13.7142C14.3594 7.78283 14.9218 8.22205 15.0784 8.84806C15.2215 9.42036 15.7085 9.84125 16.2954 9.89994L20.2648 10.2969C19.4764 6.45416 16.0755 3.56408 11.9996 3.56408C7.92364 3.56408 4.52281 6.45416 3.73438 10.2969L7.70375 9.89994Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4062 12C13.4062 12.7766 12.7766 13.4062 12 13.4062C11.2234 13.4062 10.5938 12.7766 10.5938 12C10.5938 11.2234 11.2234 10.5938 12 10.5938C12.7766 10.5938 13.4062 11.2234 13.4062 12Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5445_82997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteer);
export default __webpack_public_path__ + "static/media/steer.b7899cc07451932177e666993569cc75.svg";
export { ForwardRef as ReactComponent };